document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.hc-offcanvas-nav li.nav-parent').forEach(item => {
        const checkbox = item.querySelector('input.hc-chk');
        const submenu = item.querySelector('.sub-menu');

        if (!submenu) return;

        // Initialisation : si le checkbox est déjà coché
        if (checkbox.checked) {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            submenu.style.opacity = "1";
        } else {
            submenu.style.maxHeight = "0";
            submenu.style.opacity = "0";
        }

        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                // Ouvrir le sous-menu
                submenu.style.display = 'block';
                const height = submenu.scrollHeight;
                submenu.style.maxHeight = height + "px";
                submenu.style.opacity = "1";
            } else {
                // Fermer le sous-menu
                submenu.style.maxHeight = submenu.scrollHeight + "px"; // hauteur actuelle
                submenu.style.opacity = "1";

                // forcer reflow pour lancer la transition
                submenu.offsetHeight;

                submenu.style.maxHeight = "0";
                submenu.style.opacity = "0";

                // après la transition, masquer l'élément pour éviter overflow
                setTimeout(() => {
                    submenu.style.display = '';
                }, 350); // doit correspondre à la durée max-height de la transition
            }
        });
    });
});
